/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay} from '@chakra-ui/react'
import ProductView from '../../partials/product-view'
import {useProductViewModal} from '../../hooks/use-product-view-modal'

/**
 * A Modal that contains Product View
 */
const ProductViewModal = ({product, isOpen, onClose, context, ...props}) => {
    const productViewModalData = useProductViewModal(product)
    return (
        <Modal
            variant="productView"
            size="lg"
            isOpen={isOpen}
            onClose={onClose}
            colorScheme="stokkeCore"
            returnFocusOnClose={
                // restoring the focus prevents the page from scrolling to the top
                false
            }
        >
            <ModalOverlay />
            <ModalContent containerProps={{'data-testid': 'product-view-modal'}}>
                <ModalCloseButton />
                <ModalBody>
                    <ProductView
                        showFullLink={true}
                        context={context}
                        imageSize="sm"
                        product={productViewModalData.product}
                        isLoading={productViewModalData.isFetching}
                        onClose={onClose}
                        {...props}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

ProductViewModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    isLoading: PropTypes.bool,
    context: PropTypes.string,
    actionButtons: PropTypes.node,
    onModalClose: PropTypes.func
}

export default ProductViewModal
